"use client";

import { Box, Flex, Text } from "@chakra-ui/react";
import { UnlockPrompt } from "@/_components/ui/UnlockPrompt";
import { Emoji } from "@/_components/ui/Emoji/Emoji";
import { ATSResume } from "@/_components/ui/ATSResume";
import { FullViewResume } from "@/_models/resume";
import { useTranslations } from "next-intl";
import { FaLock } from "react-icons/fa";
import { RESUME_DETAIL_RESUME_NS } from "./constants";

export interface DigitalVersionContentProps {
  fullResume?: FullViewResume;
  onClickUnlock: () => void;
  isLoading?: boolean;
}

export function DigitalVersionContent({
  fullResume,
  onClickUnlock,
  isLoading,
}: DigitalVersionContentProps) {
  const t = useTranslations(RESUME_DETAIL_RESUME_NS);

  return (
    <Box
      id="resume-digital-version-content"
      boxSize="full"
      display="flex"
      justifyContent="center"
      alignItems="center"
      position="relative"
    >
      {fullResume?.download_url ? (
        <Flex
          flexDirection="row"
          alignItems="start"
          gap={4}
          boxSize="full"
          justifyContent="center"
          id="resume-digital-version-content-container"
        >
          <ATSResume
            data={fullResume}
            showExportButton={true}
            exportButtonText={t("unlock.download_digital_resume")}
            onExportStart={() => {}}
            onExportSuccess={() => {}}
            onExportError={() => {}}
          />
        </Flex>
      ) : (
        <UnlockPrompt
          icon={<Emoji emoji="high-voltage" size={6} />}
          title={t("unlock.digital_title")}
          description={
            <>
              <Text
                as="span"
                fontWeight="bold"
                color="orange.500"
                textTransform="uppercase"
              >
                {t("unlock.unlock_now")}
              </Text>{" "}
              {t("unlock.digital_description")}
            </>
          }
          buttonText={t("unlock.unlock_now_button")}
          buttonIcon={FaLock}
          onUnlock={onClickUnlock}
          isLoading={isLoading}
          isAbsolute={false}
        />
      )}
    </Box>
  );
}
